// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getBrandActiveState from "@sc/App/Widgets/SearchEngineOptimization/ActiveState/Brand";
import { SeoAppProps, SeoHandlerProps } from "@sc/App/Widgets/SearchEngineOptimization/Type";
import { Brand, CollectionPage, Graph, WithContext } from "@sc/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaBrand = ({ payload, url }: SeoAppProps): Graph => {
    const brands = payload.brands;

    const brandSchema =
        brands?.map((brand): WithContext<Brand> => {
            if (brand.logoSmallImagePath) {
                return {
                    "@context": "https://schema.org",
                    "@type": "Brand",
                    name: brand.name,
                    description: brand.name,
                    logo: brand.logoSmallImagePath,
                    image: brand.logoSmallImagePath,
                    url: url + brand.detailPagePath,
                };
            }

            return {
                "@context": "https://schema.org",
                "@type": "Brand",
                name: brand.name,
                description: brand.name,
                url: url + brand.detailPagePath,
            };
        }) || [];

    const brandCategories =
        payload?.brandCategories?.map(
            (item): WithContext<CollectionPage> => ({
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                name: item.categoryName,
                description: item.categoryShortDescription,
                image: item.featuredImagePath,
                url: url + item.productListPagePath,
            }),
        ) || [];

    return {
        "@context": "https://schema.org",
        "@graph": [...brandSchema, ...brandCategories],
    };
};

export default {
    isActivate: getBrandActiveState,
    buildSchema: loadSchemaBrand,
} as SeoHandlerProps;
